import Login from './login'
import LyLogin from './leyoulogin'
import {isLeYou} from '@/shared/utils/constant'

export default [{
    path: '/login',
    name:'login',
    component:Login
},{
    path: '/leyoulogin',
    name:'lylogin',
    component:LyLogin
},{
    path: '',
    redirect:{name: isLeYou? 'lylogin':'login'}
}]